<template>
  <shipblu-prompt
    class="shipment-modal"
    @close="closeModal"
    @cancel="closeModal"
    :active.sync="selectLocationsModal"
    :title="$t('Your Locations')"
    :buttons-hidden="true">
    <div class="text-center">
      <p class="text-darkgray text-base mb-4">{{$t('Select your payment method.')}}</p>
      <div class="flex sm:mt-0 mt-6 items-center justify-center">
        <div v-for="(method, index) in paymentTypes" :key="index">
          <label @click="checkedItem(method, paymentTypes)" class="prompt cursor-pointer" :class="index === 0 ? 'mr-4' : ''">
            <input v-model="payment.pay_using" :class="payment.pay_using && payment.pay_using.checked === method.checked ? 'checked' : ''" :value="method" type="radio" />
            <span class="py-2 px-4 rounded text-sm">{{ $t(method.name) }}</span>
          </label>
        </div>
      </div>
    </div>

    <div class="vx-row mb-2 p-6 justify-content">
      <p class="font-medium text-xs">{{ $t('Select one of your locations') }}</p>
      <v-select :class="pickupPoint ? 'pickup-point-filled' : ''" class="pickup-point w-full" v-model="pickupPoint" v-validate="'required'"
        placeholder="Add pickup Point" name="pickup point" label="fullAddress" :options="pickupPoints"/>
      <span class="text-danger text-sm" v-show="errors.has('pickup point')">{{ errors.first('pickup point') }}</span>
    </div>
    <shipblu-button :disabled="buttonClicked > 0" @click="sendLocation()" size="small" color="primary" :textButton="$t('Confirm')" id="pay-btn-loading" class="vs-con-loading__container mt-4 w-2/3 m-auto" />
  </shipblu-prompt>
</template>

<script>
import vSelect from 'vue-select'
import ShipbluPrompt from '../../layouts/components/ShipBluPrompt.vue'
import { sendRequest } from '../../http/axios/requestHelper'
import common from '../../assets/utils/common'

export default {
  props: ['selectLocationsModal', 'payment', 'paymentType'],
  data () {
    return {
      pickupPoint: {},
      pickupPoints: [],
      merchantID: '',
      buttonClicked: 0
    }
  },
  components: {
    vSelect,
    ShipbluPrompt
  },
  watch: {
    selectLocationsModal (val) {
      if (val) {
        this.buttonClicked = 0
      }
    }
  },
  methods: {
    sendLocation () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.buttonClicked += 1
          this.$emit('payment', this.payment)
          this.$emit('pickupPoint', this.pickupPoint)
          this.$emit('checkOut')
        }
      })
    },
    closeModal () {
      this.$emit('paymentType', this.paymentType)
      this.$emit('selectLocationsModal', false)
    },
    loadPickupPoints () {
      sendRequest(false, false, this, `api/v1/merchants/${this.merchantID}/pickup-points/`, 'get', null, true,
        (response) => {
          this.pickupPoints = response.data.results
          this.pickupPoints.forEach(element => {
            element.fullAddress = element.address.line_1 + element.address.line_2 + element.address.zone.name
            if (element.is_default) {
              this.pickupPoint = element
            }
          })
        }
      )
    }
  },
  created () {
    const merchantData = common.checkMerchantInLocalStorage(this)
    merchantData.then(results => {
      const user = results.merchantData
      this.merchantID = user.id
      this.userMerchant = results.userMerchantData
      this.merchantStatus = user.status
      if (this.merchantStatus === 'active') {
        this.loadPickupPoints()
      }
    })
  }
}
</script>